import axios from 'axios';

const getWhatsAppData = async () => {

        try{
            const response = await axios.post('https://api.trucoo.in/whatsapp/get/', {}, {
                headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
            });

            //console.log("WhatsApp Data Response:", response.data);

            if(response?.data?.status === 'success'){
                return response.data.data;
            }
        }catch(error){
            console.error(error);
            return [];
        }
};

export default getWhatsAppData;
